<div #headerContainer class="header-container">
  <div class="sticky-box">
    <div
      [style.width.px]="resourcesColumnWidthPx$ | async"
      [class.sticky-shadow]="stickyHasShadow"
    >
      <div class="header d-flex align-items-center px-2">
        @let isHomeLocationKpiEnabled = isHomeLocationKpiEnabled$ | async;
        <wilson-search-filter
          class="w-100"
          [placeholder]="
            (isHomeLocationKpiEnabled
              ? 'page.shift_timeline.search_placeholder.user_and_location'
              : 'page.shift_timeline.search_placeholder.user'
            ) | translate
          "
          (modelChange)="updateSearchTerm($event)"
        ></wilson-search-filter>
      </div>
    </div>
  </div>

  @if (frameLength$ | async; as frameLength) {
    <div>
      <div [style.width.px]="frameLength">
        <wilson-shift-timeline-date-header
          [panelWidth]="frameLength"
          [interval]="timeframe$ | async"
          [hoursRange]="hoursRange$ | async"
          [stickyHasShadow]="stickyHasShadow"
          [zoomLevel]="zoomLevel$ | async"
          [holidayRegions]="publicHolidaysRegion$ | async"
          [visibleDaysRange]="visibleDaysRange$ | async"
        ></wilson-shift-timeline-date-header>
      </div>
    </div>
  }
</div>
